export default function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#E8B4A8] to-[#D4A29A]">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl text-center">
        <h2 className="text-4xl lg:text-5xl font-light text-white mb-6">
          Prête à transformer votre peau ?
        </h2>
        <p className="text-lg text-white/90 mb-10 max-w-2xl mx-auto">
          Rejoignez des milliers de femmes qui ont déjà découvert le secret d'une peau éclatante et radieuse
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="/#contact"
            className="px-10 py-4 bg-white text-gray-900 text-base font-semibold rounded-full hover:bg-gray-50 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg"
          >
            Prendre rendez-vous
          </a>
          <a 
            href="/soins-esthetiques"
            className="px-10 py-4 border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Découvrir nos soins
          </a>
        </div>

        {/* Garanties */}
        <div className="grid md:grid-cols-2 gap-8 mt-16 pt-12 border-t border-white/20 max-w-xl mx-auto">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-3">
              <i className="ri-truck-line text-3xl text-white"></i>
            </div>
            <p className="text-sm text-white font-medium">Livraison offerte dès 49,99€</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center mb-3">
              <i className="ri-customer-service-line text-3xl text-white"></i>
            </div>
            <p className="text-sm text-white font-medium">Support client 7j/7</p>
          </div>
        </div>
      </div>
    </section>
  );
}
